/**
 * Indicates the status of newsletter subscription.
 *
 * @enum
 * @category Page View
 */
export var NewsletterStatus;
(function (NewsletterStatus) {
    NewsletterStatus[NewsletterStatus["UNSUBSCRIBED"] = 0] = "UNSUBSCRIBED";
    NewsletterStatus[NewsletterStatus["DAILY"] = 1] = "DAILY";
    NewsletterStatus[NewsletterStatus["WEEKLY"] = 2] = "WEEKLY";
    NewsletterStatus[NewsletterStatus["ALL_SUBSCRIBED"] = 3] = "ALL_SUBSCRIBED";
    NewsletterStatus[NewsletterStatus["NOT_DOUBLE_OPT_IN"] = 4] = "NOT_DOUBLE_OPT_IN";
})(NewsletterStatus || (NewsletterStatus = {}));
/**
 * Indicates the Plus status of the customer.
 *
 * @enum
 * @category Page View
 */
export var PlusStatus;
(function (PlusStatus) {
    PlusStatus[PlusStatus["NOT_ELIGIBLE"] = 0] = "NOT_ELIGIBLE";
    PlusStatus[PlusStatus["PLUS_MEMBER"] = 1] = "PLUS_MEMBER";
    PlusStatus[PlusStatus["ELIGIBLE_WITH_FREE_TRIAL"] = 2] = "ELIGIBLE_WITH_FREE_TRIAL";
    PlusStatus[PlusStatus["ELIGIBLE_WITHOUT_FREE_TRIAL"] = 3] = "ELIGIBLE_WITHOUT_FREE_TRIAL";
})(PlusStatus || (PlusStatus = {}));
//# sourceMappingURL=pageView.js.map